import { REACT_APP_API_URL } from "../../setup/config";
import axios, { handleApiError } from '../axios';

export const getProformaInvoiceByBuyerPOId = async (buyerPOId) => {
    try {
        const response = await axios.get(`${REACT_APP_API_URL}/proforma-invoice/proformaInvoiceByBuyerPOId/${buyerPOId}`);
        return response.data;
    } catch (error) {
        console.log("getProformaInvoiceByBuyerPOId - error", error)
        return handleApiError(error)
    }
}


export const getProformaInvoiceByProformaInvoiceId = async (proformaInvoiceId) => {
    try {
        const response = await axios.get(`${REACT_APP_API_URL}/proforma-invoice/${proformaInvoiceId}`);
        return response.data;
    } catch (error) {
        console.log("getProformaInvoiceByBuyerPOId - error", error)
        return handleApiError(error)
    }
}

export const insertProformaInvoice = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/proforma-invoice/create`, data);
        return await response.data;
    } catch (error) {
        console.log("insertProformaInvoice - error", error)
        return handleApiError(error)
    }
}

export const getProformaInvoiceDocument = async (proformaInvoiceId) => {
    try {
        const response = await axios.get(`${REACT_APP_API_URL}/proforma-invoice/profromaInvoiceDocument/${proformaInvoiceId}`);
        return await response.data;
    } catch (error) {
        console.log("getProformaInvoiceDocument - error", error)
        return handleApiError(error)
    }
}

export const getProformaInvoiceByDocNo = async (docNo) => {
    try {
        const response = await axios.get(`${REACT_APP_API_URL}/proforma-invoice/get-proforma-invoice-by-doc-no/${docNo}`);
        return response.data;
    } catch (error) {
        console.log("getProformaInvoiceByDocNo - error", error)
        return handleApiError(error)
    }
}
